import React from 'react'

import { useSegmentList } from '../hooks'

import IncidentDate from '../../incidents/components/IncidentDate'

import styles from './SegmentList.module.css'

const DetailsSegmentList = () => {
  const [segments, { onHover, onHoverEnd, zoom }] = useSegmentList()

  return (
    <ul className={styles.list}>
      {segments.map((segment, i) => (
        <li
          key={i}
          className={styles.listItem}
          onMouseEnter={onHover(segment.id)}
          onMouseLeave={onHoverEnd(segment.id)}
          onClick={zoom(segment)}
        >
          <div className={styles.meta}>Closed</div>
          <div className={styles.name}>
            {segment.name}, {segment.city}
          </div>
          <IncidentDate style={styles.meta} date={segment.closedSince} />
          <div className={styles.block}>{segment.block}</div>
        </li>
      ))}
    </ul>
  )
}

export default DetailsSegmentList
